// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1SuPU","fileBtn":"File_fileBtn__3I1LZ","closeBtn":"File_closeBtn__2Dops","fileSelected":"File_fileSelected__M3hjM","disabled":"File_disabled__jHsmE"};